import React from "react";

const CourseCard = ({ level, title, bullets, href }) => (
  <div className="levels__card">
    <div className="levels__top">
      <span className="levels__crumb">CMT Prep Program</span>
      <span className="levels__lvl">Level {level}</span>
    </div>
    <h3 className="levels__title">{title}</h3>
    <ul className="levels__list">
      {bullets.map((b, i) => <li key={i}>{b}</li>)}
    </ul>
    <div className="levels__cta">
      <a className="btn btn--ghost" href="#contact">Enroll</a>
      {/* <a className="btn btn--primary" href={href}>View Program</a> */}
    </div>
  </div>
);

export default function CoursesByLevel() {
  return (
    <section className="levels" id="levels">
      <div className="container">
        <h2 className="section__title">You'll master the following course modules</h2>
        <p className="section__subtitle">Start where you are, progress where you want. Courses designed for every stage, mentored by top practitioners.</p>
        <div className="levels__grid">
<CourseCard
  level="1"
  title="Foundational Principles of Technical Analysis"
  bullets={[
          "Theory and History of Technical Analysis",
          "Market Price Data",
          "Trend Analysis",
          "Chart Patter Analysis",
          "Technical Indicators",
          "Statistics for Technicians",
          "Behavioural Finance",
          "Sentiment",
          "Cycle Analysis",
          "Corporative Market Analysis",
          "Volatility Analysis",
          "Systems and Quantitative Analysis",
  ]}
  href="#level1"
/>
          <CourseCard
            level="2"
            title="Application of Technical Analysis Methods"
            bullets={[      "Behavioural Finance",
          "Charts: Organizing Market Data",
          "Chart Pattern Analysis",
          "Trend Analysis",
          "Volatility Analysis",
          "Sentiment",
          "Statistics for Technicians",
          "Technical Indicators",
          "Comparative Market Analysis",
          "Cycle Analysis",
          "Systems and Quantitative Methods"]}
            href="#level2"
          />
          <CourseCard
            level="3"
            title="The Work of Technical Analyst"
            bullets={[
           "Quantifying and Managing Risk",
          "Classical Chart Analysis",
          "Trend Analysis",
          "Technical Indicators",
          "Volatility Analysis",
          "Systems and Quantitative Methods",
          "Topics in Portfolio Management"]}
            href="#level3"
          />
        </div>
      </div>
    </section>
  );
}
